import { useMemo } from 'react';
import { BrandliveEvent, Session, SessionPreview } from '../types/working-model';
import { toDictTyped } from './utils';

function useGetSessionTags(event: BrandliveEvent | null, session: Session | SessionPreview) {
	if (!event || !session) return [];

	const sessionTags = useMemo(() => {
		const tagMap = toDictTyped('uuid', event.tags ?? []);
		return session?.tags?.map(t => tagMap[t]).filter(t => !!t) ?? [];
	}, [event.tags, session?.tags]);

	return sessionTags;
}

export default useGetSessionTags;
